export const QueryParamTypes = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  JSON: 'json',
  DATE: 'date',
  DATETIME: 'datetime',
  TIME: 'time',
} as const;
